import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from 'app/globals';
import { RatersService } from 'app/services/rater/RatersService';

@Component({
  selector: 'app-rater-assessment',
  templateUrl: './rater-assessment.component.html',
  styleUrls: ['./rater-assessment.component.scss']
})
export class RaterTakeAssessmentComponent implements OnInit {
    assessmentId: number;

    constructor(
        private activatedRoute: ActivatedRoute,
        private _RatersService: RatersService,
        private _Globals: Globals,
        private _Router: Router
    ) {
        this.activatedRoute.params.subscribe(params => {
            console.log('id', params['id']);
            this.assessmentId = parseInt(params['id']);
            this.getAssessmentDetails();
        });
    }

    ngOnInit() {}

    getAssessmentDetails() {
        this._RatersService.getAssessmentDetails(this.assessmentId).subscribe(data => {
            console.log("response_GetAssessmentDetails", data);
            if (data != null) {
                this._Globals.raterAssessmentId = this.assessmentId;
                this._Globals.raterAssignedAssessment = data.result.AssignedAssessment;
                this._Globals.raterEmail = data.result.Email;
                this._Globals.raterAssessmentName = data.result.AssessmentName;

                console.log("Globals", this._Globals);

                this._Globals.deleteAllStorage();
                this._Router.navigate(['/login']);
            }
        })
    }

}
